import { combineReducers } from 'redux';

import { commonRootReducers } from '..';
import filtersReducer from './filters/reducers';
import controlsReducer from './controls/reducers';
import breadcrumbsReducer from './breadcrumbs/reducers';
import productsReducer from './products/reducers';
import takeawayReducer from './takeaway/reducers';
import productsSEOListReducer from './seo/reducers';
import titleReducer from './title/reducers';
import fancyReducer from './fancy/reducers';
import outOfStockReducer from './outofstock/reducers';
import detailsModalReducer from './detailsModal/reducers';
import recentlyViewedReducer from '../widgets/recentlyViewedProducts/reducers';

export default combineReducers({
  ...commonRootReducers,
  body: (state = {}, action) => ({
    ...state,
    filters: filtersReducer(state.filters, action),
    controls: controlsReducer(state.controls, action),
    breadcrumbs: breadcrumbsReducer(state.breadcrumbs, action),
    products: productsReducer(state.products, action),
    takeawayControls: takeawayReducer(state.takeawayControls, action),
    productsSEOList: productsSEOListReducer(state.productsSEOList, action),
    title: titleReducer(state.title, action),
    fancy: fancyReducer(state.fancy, action),
    outOfStockProducts: outOfStockReducer(state.outOfStockProducts, action),
    detailsModal: detailsModalReducer(state.detailsModal, action),
    recentlyViewedProducts: recentlyViewedReducer(state.recentlyViewedProducts, action),
  }),
});
